import React from "react";
import { ArrowLeft } from "lucide-react";
import { cn } from "../../../lib/cn";

/**
 * PageHeader — cabecera de página estilo mockup.
 *
 * Estructura: [← Atrás] · [Título grande / Subtítulo gris] · [slot derecho]
 *
 * El botón "atrás" es un círculo discreto que dispara `onBack`. Si no
 * se pasa `onBack`, no se muestra.
 *
 * NOTA: este componente NO incluye un mini-header sticky propio. Si
 * quieres que sea sticky, envuélvelo en un <div className="sticky top-X ...">
 * en la pantalla que lo use.
 */

export function PageHeader({
  title,
  subtitle,
  onBack,
  backTitle = "Atrás",
  action,
  className,
}) {
  return (
    <div className={cn("flex items-center gap-4", className)}>
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          title={backTitle}
          aria-label={backTitle}
          className={cn(
            "w-10 h-10 grid place-items-center rounded-md shrink-0",
            "text-slate-500 hover:text-slate-900 hover:bg-slate-100",
            "transition-colors"
          )}
        >
          <ArrowLeft className="w-5 h-5" strokeWidth={1.75} />
        </button>
      )}

      <div className="flex-1 min-w-0">
        <h1 className="text-xl font-semibold text-slate-900 leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-slate-500 mt-0.5">
            {subtitle}
          </p>
        )}
      </div>

      {action && (
        <div className="shrink-0">
          {action}
        </div>
      )}
    </div>
  );
}
